// ChipGroup.tsx
import { m } from "framer-motion";
import { SPRING_TOUCH } from "../motion/tokens";
import { cn } from "@/lib/utils";

export function ChipGroup<T extends string>({ options, value, onToggle, label, single }: {
  options: { id: T; label: string }[]; value: T[]; onToggle(id: T): void; label: string; single?: boolean;
}) {
  return (
    <div role={single ? "radiogroup" : "group"} aria-label={label} className="flex flex-wrap gap-2">
      {options.map((o) => {
        const on = value.includes(o.id);
        return (
          <m.button key={o.id} type="button" onClick={() => onToggle(o.id)}
            role={single ? "radio" : undefined} aria-checked={single ? on : undefined} aria-pressed={single ? undefined : on}
            whileTap={{ scale: 0.95 }} transition={SPRING_TOUCH}
            className={cn("relative overflow-hidden rounded-full border px-3.5 py-1.5 text-sm transition-colors",
              on ? "border-[var(--color-primary)] text-[var(--color-bg)]" : "border-[var(--color-border)] text-[var(--color-text)] hover:border-[var(--color-text-muted)]")}>
            {on && <m.span layoutId={single ? `${label}-single` : undefined} className="absolute inset-0 bg-[var(--color-primary)]"
              initial={{ scale: 0, opacity: 0.6 }} animate={{ scale: 1, opacity: 1 }} transition={SPRING_TOUCH} style={{ borderRadius: 999 }} />}
            <span className="relative">{o.label}</span>
          </m.button>
        );
      })}
    </div>
  );
}
